import { ActorViewModelSubscriptionTypes } from '@caslink/common-client/ng-app/alerts/typings/models';
import { CardStatus } from '@caslink/common-client/ng-app/alerts/typings/CardStatus';
import { SubscriptionTypes } from '@caslink/common-client/ng-app/alerts/typings/SubscriptionTypes';
import { NotificationService } from '@caslink/common-client/ng-app/notification/NotificationService';

import {
    ICardStatus, ISensorDetailModel,
    IViewModelConfirmationSubscription, IViewModelConfirmationSubscriptionState
} from '../models/models';

import { Injectable } from '@angular/core';

/**
 * Abstract some of the logic away from implementations of IDeviceModel to reduce code repetition -- especially
 * constructors of derived classes
 */

@Injectable({
    providedIn: 'root'
})
export class DeviceModelService {
    public static $name = 'deviceModelService';

    constructor(
        private notificationService: NotificationService
    ) {
    }

    public formatSensorDisplayValue(sensor: ISensorDetailModel) {
        // tslint:disable-next-line: triple-equals
        let sensorFormatted = sensor.isOnOff ? sensor.sensorValue == 1 ? 'On' : 'Off' : sensor.sensorValue;
        return sensorFormatted + (sensor.postfix || '');
    }

    public getStatus(statusText: CardStatus): ICardStatus {
        switch (statusText) {
            case 'Ready':
            case 'Received':
                return { materialIcon: 'rss_feed', klass: 'ready', statusText: statusText };

            case 'Submitting':
                return { materialIcon: 'arrow_forward', klass: 'submit', statusText: statusText };

            case 'Transmitted':
                return { materialIcon: 'repeat', klass: 'transmit', statusText: statusText };

            default:
                return { materialIcon: 'cancel', klass: 'not-responding', statusText: statusText };
        }
    }

    public setupLiveViewModels(
        locationId,
        areaId,
        controlSummaryViewModel: CASLink.Device.Ui.ViewModel.DynamicControls.ControlSummaryViewModel
    ) {
        // tslint:disable-next-line:no-console
        console.log('START LISTENING!!!!!', locationId, areaId, controlSummaryViewModel);
        this.notificationService.startUpdates(locationId, SubscriptionTypes.ViewModel, {
            areaId: areaId,
            actorViewModelSubscriptionType: ActorViewModelSubscriptionTypes.ViewModelUpdate,
            identifier: controlSummaryViewModel.identifier
        }, { originalViewModel: controlSummaryViewModel });
    }

    public stopLiveViewModels(
        locationId,
        areaId,
        controlSummaryViewModel: CASLink.Device.Ui.ViewModel.DynamicControls.ControlSummaryViewModel
    ) {
        // tslint:disable-next-line:no-console
        console.log('STOP LISTENING!!!!!', locationId, areaId, controlSummaryViewModel);
        this.notificationService.stopUpdates(locationId, SubscriptionTypes.ViewModel, {
            areaId: areaId,
            actorViewModelSubscriptionType: ActorViewModelSubscriptionTypes.ViewModelUpdate,
            identifier: controlSummaryViewModel.identifier
        });
    }

    public setupRtuStatusSubscription(locationId, hardwareItemId: number) {
        this.notificationService.startUpdates(locationId, SubscriptionTypes.RtuStatus, { hardwareItemId: hardwareItemId }, null);
    }

    public setupSensorSubscription(locationId, sensorId: number) {
        this.notificationService.startUpdates(locationId, SubscriptionTypes.SensorUpdate, { sensorId: sensorId }, null);
    }

    public startViewModelConfirmationSubscription(
        locationId: number,
        areaId: number,
        confirmationSubscription: IViewModelConfirmationSubscription,
        subscriptionState: IViewModelConfirmationSubscriptionState
    ) {
        // must stop previous one if it existed
        this.stopViewModelConfirmationSubscription(locationId, areaId, confirmationSubscription);

        this.notificationService.startUpdates(locationId, SubscriptionTypes.ViewModel, {
            areaId: areaId,
            actorViewModelSubscriptionType: ActorViewModelSubscriptionTypes.ViewModelUpdateConfirmation,
            identifier: subscriptionState.originalViewModel.identifier
        }, subscriptionState);

        return { subscriptionState: subscriptionState };
    }

    public stopViewModelConfirmationSubscription(
        locationId: number,
        areaId: number,
        confirmationSubscription: IViewModelConfirmationSubscription
    ) {
        if (confirmationSubscription) {
            this.notificationService.stopUpdates(locationId, SubscriptionTypes.ViewModel, {
                areaId: areaId,
                actorViewModelSubscriptionType: ActorViewModelSubscriptionTypes.ViewModelUpdateConfirmation,
                identifier: confirmationSubscription.subscriptionState.originalViewModel.identifier
            });

            confirmationSubscription = null;
        }
    }
}
